import { render, staticRenderFns } from "./TheModalHeader.vue?vue&type=template&id=7eb8a8eb&scoped=true"
import script from "./TheModalHeader.vue?vue&type=script&lang=ts"
export * from "./TheModalHeader.vue?vue&type=script&lang=ts"
import style0 from "./TheModalHeader.vue?vue&type=style&index=0&id=7eb8a8eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb8a8eb",
  null
  
)

export default component.exports